import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { getQuickReply } = createActions({
  getQuickReply: result => {
    return result;
  }
});

const initState = Map({
  myQuickReply: [],
  enterpriseQuickReply: []
});

const quickReply = handleActions(
  {
    [getQuickReply]: (state, action) => {
      const { agent_quick_reply_group, ent_quick_reply_group } = action.payload;

      agent_quick_reply_group.forEach(item => item.quick_replies.sort((a, b) => a.rank - b.rank));
      ent_quick_reply_group.forEach(item => item.quick_replies.sort((a, b) => a.rank - b.rank));

      return state
        .set(
          'myQuickReply',
          agent_quick_reply_group.sort((a, b) => a.rank - b.rank)
        )
        .set(
          'enterpriseQuickReply',
          ent_quick_reply_group.sort((a, b) => a.rank - b.rank)
        );
    }
  },
  initState
);

export default quickReply;
